import { Controller, useFormContext } from 'react-hook-form'
import { LkmProductType } from 'feature/registration/types'
import { SelectMultipleDropdownNew } from 'ui/SelectMultiple/SelectMultipleDropdownNew'

type LkmProductTypesProps = {
  productTypes: LkmProductType[]
  error?: string
}

export function LkmProductTypes({ productTypes, error }: LkmProductTypesProps) {
  const { control, setValue } = useFormContext()

  const options = productTypes.map(type => ({
    value: type.id,
    label: type.value,
  }))

  return (
    <Controller
      name='productTypes'
      control={control}
      render={({ field, fieldState }) => {
        const fieldValue = Array.isArray(field.value) ? field.value : []

        const handleChange = (vals: string[]) => {
          setValue('productTypes', vals, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }

        return (
          <SelectMultipleDropdownNew
            label='Типы изделий'
            options={options}
            value={fieldValue}
            onChange={handleChange}
            error={error ?? fieldState.error?.message}
            required
          />
        )
      }}
    />
  )
}
